/**
 * Categoría de gasto.
 *
 * El backend la expone como **slug de texto abierto**, no como enum cerrado: es
 * lo que envía la app del conductor y puede crecer sin avisar al front. Por eso
 * es un `string` y no una unión estricta.
 *
 * Además, en los datos históricos de desarrollo aparecen códigos numéricos en
 * texto (`"1"`, `"2"`, `"3"`) que hoy no tienen traducción conocida: 62 de las
 * 100 filas de dev. Se muestran tal cual en lugar de agruparlos bajo «Otros»
 * para no destruir información hasta que backend los mapee.
 */
export type ExpenseCategory = string;

/** Slugs conocidos, en el orden en que se ofrecen en los desplegables. */
export const EXPENSE_CATEGORIES: readonly ExpenseCategory[] = [
  'fuel-not-included',
  'toll',
  'parking',
  'wash',
  'workshop',
  'payment-itv',
  // Última de la lista: el catálogo la ofrece antes de «Otros», y aquí «Otros»
  // no se ofrece, así que en esta pantalla queda la última de todas.
  'waiting-time',
] as const;

export function isKnownExpenseCategory(value: unknown): boolean {
  return (
    typeof value === 'string' &&
    EXPENSE_CATEGORIES.includes(value as ExpenseCategory)
  );
}
